<template>
<div :class="{'container-fluid': !isSettingsComponent}">
	<apps-toolbar v-if="!isSettingsComponent" title="Apps" icon="fa-th-large"></apps-toolbar>

	<h2 v-else>Installed Addon Apps</h2>

	<addon-app-tab ui-location="Main"></addon-app-tab>
</div>
</template>

<script>
import AppsToolbar from "./AppsToolbar"
import AddonAppTab from "@/components/AddonAppTab"

export default {
	components: {
		AppsToolbar,
		AddonAppTab
	},
	props: ["isSettingsComponent"]
}
</script>
